// PERGOLUX IT WhatsApp widget + call bubble. tracking-snippet.liquid only loads it on the IT store.
(function () {
  // ===== Scope guard: only pergolux.it, not support subdomain, not the test page =====
  var host = window.location.hostname.toLowerCase();
  var path = window.location.pathname.toLowerCase();
  var isItStore = host === 'pergolux.it' || host === 'www.pergolux.it';
  var isExcluded = path.indexOf('/pages/testing-indigo') === 0;
  if (!isItStore || isExcluded) {
    return;
  }

  // ============ CONFIG ============
  var PHONE = '390684020024';
  var WA_URL = 'https://wa.me/' + PHONE;
  var TEL_URL = 'tel:+390684020024';
  var TITLE = 'PERGOLUX Italia';
  var WELCOME = 'Benvenuto in PERGOLUX! \uD83D\uDC4B';
  var CTA_LABEL = 'Chatta su WhatsApp';
  var AVATAR_URL =
    'https://pergolux.au/cdn/shop/files/cs_people_72090c54-72f5-42ff-9239-130cdfa33060.png?v=1753276965&width=375';

  var SUBTITLE_ONLINE = 'Di solito rispondiamo in pochi minuti';
  var SUBTITLE_OFFLINE = 'Lasciaci un messaggio, ti rispondiamo presto';

  var COLLAPSE_AFTER_MS = 3000; // first-load: card/pill -> icon
  var MOBILE_CARD_OPEN_MS = 5000; // mobile: card auto-collapses 5s after tap-open

  // Weekday fast-reply window, ITALIAN time (Europe/Rome). Mon-Fri 8:00-19:00.
  var BIZ_START_HOUR = 8;
  var BIZ_END_HOUR = 19;

  // ============ BUSINESS HOURS (Europe/Rome, DST-safe) ============
  function isWithinBusinessHours() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Rome',
        weekday: 'short',
        hour: 'numeric',
        hour12: false,
      }).formatToParts(new Date());
      var wd = '',
        hr = 0;
      parts.forEach(function (p) {
        if (p.type === 'weekday') wd = p.value;
        if (p.type === 'hour') hr = parseInt(p.value, 10);
      });
      if (hr === 24) hr = 0;
      var isWeekday = wd === 'Mon' || wd === 'Tue' || wd === 'Wed' || wd === 'Thu' || wd === 'Fri';
      return isWeekday && hr >= BIZ_START_HOUR && hr < BIZ_END_HOUR;
    } catch (e) {
      return true;
    }
  }
  var SUBTITLE = isWithinBusinessHours() ? SUBTITLE_ONLINE : SUBTITLE_OFFLINE;

  // ============ TOUCH DETECTION ============
  var isTouch =
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    window.matchMedia('(pointer: coarse)').matches;

  // ============ STYLES ============
  var css = [
    '#pgx-wa-root{position:fixed;bottom:20px;right:20px;z-index:2147483000;',
    'transition:bottom .3s cubic-bezier(.4,0,.2,1);',
    'font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;}',
    // ----- phone bubble: white, static, sits above the WhatsApp button -----
    '#pgx-call-btn{position:absolute;right:4px;bottom:66px;width:46px;height:46px;border-radius:50%;',
    'background:#fff;display:flex;align-items:center;justify-content:center;',
    'border:1px solid rgba(0,0,0,0.08);box-shadow:0 3px 12px rgba(0,0,0,.22);',
    'text-decoration:none;-webkit-tap-highlight-color:transparent;z-index:2147483001;',
    'opacity:1;transform:scale(1);transition:opacity .2s ease,transform .2s ease;}',
    '#pgx-call-btn.pgx-call-hidden{opacity:0;transform:scale(.6);pointer-events:none;}',
    '#pgx-call-btn svg{width:22px;height:22px;}',
    '#pgx-call-btn:hover{box-shadow:0 4px 16px rgba(0,0,0,.28);}',
    // ----- whatsapp card -----
    '#pgx-wa-card{position:absolute;bottom:64px;right:0;width:250px;background:#fff;',
    'border-radius:14px;overflow:hidden;box-shadow:0 6px 22px rgba(0,0,0,0.16);',
    'transform-origin:bottom right;',
    'transition:opacity .32s cubic-bezier(.4,0,.2,1),transform .32s cubic-bezier(.4,0,.2,1);}',
    '#pgx-wa-card.pgx-hidden{opacity:0;transform:scale(.5) translateY(20px);pointer-events:none;}',
    '#pgx-wa-card .pgx-head{background:#075E54;padding:11px 13px;display:flex;align-items:center;gap:9px;}',
    '#pgx-wa-card .pgx-av{width:36px;height:36px;border-radius:50%;flex-shrink:0;object-fit:cover;background:#128C7E;}',
    '#pgx-wa-card .pgx-ttl{color:#fff;line-height:1.25;min-width:0;}',
    '#pgx-wa-card .pgx-ttl .t1{font-size:13px;font-weight:500;}',
    '#pgx-wa-card .pgx-ttl .t2{font-size:11px;opacity:.82;}',
    '#pgx-wa-card .pgx-body{padding:13px;background:#ECE5DD;}',
    '#pgx-wa-card .pgx-bubble{background:#fff;padding:9px 11px;border-radius:7px;font-size:12px;',
    'line-height:1.35;box-shadow:0 1px 1px rgba(0,0,0,.06);color:#111;}',
    '#pgx-wa-card .pgx-bubble .b1{font-size:10px;color:#075E54;font-weight:500;margin-bottom:3px;}',
    '#pgx-wa-card .pgx-cta{display:block;margin-top:10px;background:#fff;border-radius:7px;padding:10px;',
    'text-align:center;color:#128C7E;font-size:13px;font-weight:500;cursor:pointer;text-decoration:none;}',
    // ----- whatsapp button -----
    '#pgx-wa-btn{position:absolute;bottom:0;right:0;background:#25D366;color:#fff;border-radius:999px;',
    'display:flex;align-items:center;gap:8px;padding:13px;font-size:14px;font-weight:500;cursor:pointer;',
    'white-space:nowrap;overflow:hidden;box-shadow:0 4px 14px rgba(0,0,0,.18);text-decoration:none;',
    '-webkit-tap-highlight-color:transparent;transition:padding .3s cubic-bezier(.4,0,.2,1);}',
    '#pgx-wa-btn .pgx-lbl{max-width:0;opacity:0;overflow:hidden;',
    'transition:max-width .3s cubic-bezier(.4,0,.2,1),opacity .25s,margin .3s;}',
    '#pgx-wa-btn.pgx-open{padding:12px 16px;}',
    '#pgx-wa-btn.pgx-open .pgx-lbl{max-width:200px;opacity:1;margin-left:2px;}',
    '@media(max-width:640px){',
    '#pgx-wa-root{bottom:16px;right:16px;}',
    '#pgx-wa-card{width:210px;bottom:58px;}',
    '#pgx-wa-btn{font-size:13px;padding:12px;}',
    '#pgx-call-btn{width:46px;height:46px;bottom:60px;right:2px;}',
    '}',
    // ----- lift above the sticky bottom bar so the bubbles clear its CTA (mobile only) -----
    // Bars flag themselves hidden with .translate-y-full; the bubbles ride back down.
    '@media(max-width:767px){',
    'body:has([data-vue-mount^="pdpx-sticky-cta"]:not(.translate-y-full)) #pgx-wa-root,',
    'body:has([data-vue-mount^="enclosed-sticky-cta"]:not(.translate-y-full)) #pgx-wa-root,',
    'body:has(div:not(.translate-y-full)>.pgx-sticky-breakdown-container) #pgx-wa-root{',
    'bottom:105px;}',
    '}',
    '@media(prefers-reduced-motion:reduce){',
    '#pgx-wa-root,#pgx-wa-card,#pgx-wa-btn,#pgx-wa-btn .pgx-lbl,#pgx-call-btn{transition:none;}',
    '}',
  ].join('');
  var styleEl = document.createElement('style');
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  // ============ ICONS ============
  var WA_ICON =
    '<svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor" aria-hidden="true">' +
    '<path d="M19.05 4.91A9.82 9.82 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.9 9.9 0 0 0 4.74 1.21h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.91-7.01zM12.05 20.15h-.01a8.23 8.23 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.18 8.18 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24 2.2 0 4.27.86 5.83 2.42a8.19 8.19 0 0 1 2.41 5.83c.01 4.54-3.69 8.23-8.23 8.23zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.25-.64.81-.79.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.39.11-.51.11-.11.25-.29.37-.43.12-.14.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.23.25-.86.85-.86 2.07s.89 2.4 1.01 2.57c.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.14-1.18-.06-.1-.23-.16-.48-.28z"/></svg>';

  // dark-slate handset so the white phone bubble reads as its own thing, not a WhatsApp variant
  var PHONE_ICON =
    '<svg viewBox="0 0 24 24" fill="#1f4d33" aria-hidden="true">' +
    '<path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.18z"/></svg>';

  // ============ DOM ============
  var root = document.createElement('div');
  root.id = 'pgx-wa-root';
  root.innerHTML =
    '<a id="pgx-call-btn" href="' +
    TEL_URL +
    '" aria-label="Chiama PERGOLUX Italia">' +
    PHONE_ICON +
    '</a>' +
    '<div id="pgx-wa-card">' +
    '<div class="pgx-head">' +
    '<img class="pgx-av" src="' +
    AVATAR_URL +
    '" alt="" onerror="this.style.display=\'none\'">' +
    '<div class="pgx-ttl">' +
    '<div class="t1">' +
    TITLE +
    '</div>' +
    '<div class="t2">' +
    SUBTITLE +
    '</div>' +
    '</div>' +
    '</div>' +
    '<div class="pgx-body">' +
    '<div class="pgx-bubble"><div class="b1">' +
    TITLE +
    '</div>' +
    WELCOME +
    '</div>' +
    '<a class="pgx-cta" href="' +
    WA_URL +
    '" target="_blank" rel="noopener noreferrer">' +
    CTA_LABEL +
    '</a>' +
    '</div>' +
    '</div>' +
    '<a id="pgx-wa-btn" href="' +
    WA_URL +
    '" target="_blank" rel="noopener noreferrer" aria-label="' +
    CTA_LABEL +
    '">' +
    WA_ICON +
    '<span class="pgx-lbl">' +
    CTA_LABEL +
    '</span>' +
    '</a>';

  function mount() {
    document.body.appendChild(root);
    initBehavior();
  }
  if (document.body) mount();
  else document.addEventListener('DOMContentLoaded', mount);

  // ============ BEHAVIOR ============
  function initBehavior() {
    var card = document.getElementById('pgx-wa-card');
    var btn = document.getElementById('pgx-wa-btn');
    var callBtn = document.getElementById('pgx-call-btn');
    var timer;

    // Keep the phone bubble in sync with the card: hidden whenever the card is open.
    function syncCall() {
      var cardOpen = !card.classList.contains('pgx-hidden');
      callBtn.classList.toggle('pgx-call-hidden', cardOpen);
    }

    function hideCard() {
      card.classList.add('pgx-hidden');
      syncCall();
    }
    function showCard() {
      card.classList.remove('pgx-hidden');
      syncCall();
    }

    if (isTouch) {
      // ----- MOBILE: pill on landing -> icon after 3s. Tap icon opens card (5s). CTA -> WhatsApp.
      card.classList.add('pgx-hidden'); // never show the card on landing
      btn.classList.add('pgx-open'); // show the pill (icon + label) on landing
      syncCall(); // card hidden on landing -> phone bubble visible
      timer = setTimeout(function () {
        btn.classList.remove('pgx-open');
      }, COLLAPSE_AFTER_MS); // -> icon

      btn.addEventListener('click', function (e) {
        if (card.classList.contains('pgx-hidden')) {
          e.preventDefault(); // first tap opens the card, doesn't navigate
          showCard();
          clearTimeout(timer);
          timer = setTimeout(hideCard, MOBILE_CARD_OPEN_MS);
        }
        // card open: the icon sits behind it; the card's CTA handles navigation
      });
    } else {
      // ----- DESKTOP: full card on landing -> collapses to icon after 3s. Hover grows pill. Click -> WhatsApp.
      syncCall(); // card visible on landing -> phone bubble hidden for the first 3s
      timer = setTimeout(hideCard, COLLAPSE_AFTER_MS);
      btn.addEventListener('mouseenter', function () {
        if (card.classList.contains('pgx-hidden')) btn.classList.add('pgx-open');
      });
      btn.addEventListener('mouseleave', function () {
        btn.classList.remove('pgx-open');
      });
      btn.addEventListener('focus', function () {
        btn.classList.add('pgx-open');
      });
      btn.addEventListener('blur', function () {
        btn.classList.remove('pgx-open');
      });
    }
  }
})();
